import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, Injector, Input, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SNItem } from 'src/app/models/snitem';
import { SNItemTableService } from '../../snitem-table-interface';
import { SNItemTableControlComponent } from '../snitem-table-control/snitem-table-control.component';

@Component({
  selector: 'app-snitem-table',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './snitem-table.component.html',
  styleUrls: ['./snitem-table.component.scss']
})
export class SNItemTableComponent implements OnInit, AfterViewInit {

  @Input() row: string; // component name to be used as the row component
  @Input() cell: string; // component name to be used as the row component
  @Input() displayPaginator = true;
  @ViewChild(SNItemTableControlComponent) control: SNItemTableControlComponent;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  public tableservice: SNItemTableService;
  public itemInjector: Injector;
  public dataSource = new MatTableDataSource<SNItem>();

  constructor(injector: Injector, private cdr: ChangeDetectorRef) {
    this.itemInjector = Injector.create({providers: [{provide: SNItem, deps: []}], parent: injector});
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
  }

  @Input() set service(tableservice: SNItemTableService) {
    if (tableservice) {
      this.tableservice = tableservice;
      this.tableservice.data.subscribe({
        next : (newdata) => {
        this.dataSource.data = newdata;
        this.cdr.detectChanges();
      }});
    }
  }

  get fields() {
    if (this.cell) {
      return this.tableservice.fields;
    }
    return ['row'];
  }
}
